import React, { useState } from 'react';
import classNames from 'classnames';
import * as Render from '../../platformui/Base/Render';
import Section from '../../platformui/Section';
import EventArticleList from '../event-article-list';
import EventListViewToggler from './event-list-view-toggler';
import { useSweLang } from '../../platformui/Helpers/helpers';

const EventTeaserItemLink = (props) => {
  const classes = props.className
    ? props.className
    : 'medium-6 large-3 columns c-teaser-outer';

  const teaserHeadingLink = classNames({
    'c-teaser__heading--no-text': !props.Preamble,
  });

  const teaserClasses = classNames({
    'c-teaser': true,
    'c-teaser--eq-height': true,
    'c-teaser--has-img': props.Media,
  });

  return (
    <li className={classes} data-cy="ui-teaser">
      <div className={teaserClasses} aria-label={props.Title}>
        <div className="c-teaser__wrapper">
          <div className="c-teaser__content">
            <h3 className="c-teaser__heading" dir={props.Dir}>
              <a className={teaserHeadingLink} href={props.Url}>
                <span className="c-teaser__heading__link">
                  <span>{props.Title}</span>
                </span>
              </a>
            </h3>
            {props.TitleTranslation && (
              <span
                dir="ltr"
                className="c-teaser__translation"
                lang={useSweLang(props.Lang)}
              >
                {props.TitleTranslation}
              </span>
            )}
            {props.Preamble && (
              <div className="c-teaser__text">
                <p>{props.Preamble}</p>
              </div>
            )}
          </div>
        </div>
      </div>
    </li>
  );
};

const ListChildren = (props) => {
  if (!props.Items) return null;
  let masonryLayout = props.IsListOfChildren || props.masonryLayout;

  const listStyle = classNames({
    'u-flexwrap': !masonryLayout || !props.toggleBrickView,
    'u-columns': masonryLayout,
    'u-columns--gt-3': masonryLayout && props.Items.length > 3,
    'u-columns--gt-4': masonryLayout && props.Items.length > 4,
    'u-columns--is-listview': masonryLayout && !props.toggleBrickView,
    'u-flexwrap--is-listview': !props.toggleBrickView,
    'u-article--center': props.Items.length <= 2,
    ...props.WrapperModifiers,
  });

  const Items = props.Items
    .sort((a, b) => new Date(a.EventStart) - new Date(b.EventStart))
    .map((item, index) => {
    if (props.CurrentPageProps.BlockTypeName === 'DoubleColumnBlock') {
      return (
        <EventArticleList
          key={`teaser${index}`}
          {...item}
          numOfItems={props.Items.length}
          pageName={props.CurrentPageProps.BlockTypeName}
        />
      );
    } else {
      return (
        <EventArticleList
          key={`teaser${index}`}
          {...item}
          numOfItems={props.Items.length}
          pageName={props.CurrentPageProps.PageTypeName}
        />
      );
    }
  });

  let cypressValues = classNames({
    'ui-article-list': props.BlockTypeName === 'ManuelPageListBlock',
    'ui-search-article-list': props.BlockTypeName == 'SearchArticleListBlock',
  });
  if (cypressValues.length < 1) cypressValues = null;

  return props.BlockTypeName === 'PageListBlock' ? (
    <ul className={listStyle} data-cy={cypressValues}>
      {props.BlockTypeName === 'PageListBlock'
        ? Render.Property(Items, 'ListRoot')
        : Render.Property(Items, 'MainContent')}
    </ul>
  ) : (
    <div className={listStyle} data-cy={cypressValues}>
      {props.BlockTypeName === 'PageListBlock'
        ? Render.Property(Items, 'ListRoot')
        : Render.Property(Items, 'MainContent')}
    </div>
  );
};

const EventTeaser = (props) => {
  const modifiers = {
    ...props.SectionModifiers,
    'c-section--navigation': props.BlockTypeName === 'PageListBlock',
  };

  const [toggleBrickView, setToggleBrickView] = useState(!props.ShowListView);

  const showListViewToggler =
    props.BlockTypeName === 'PageListBlock' && props.UseListToggler;

  const sectionHeader = classNames({
    'c-section__header': true,
    'c-section__header--listview-shown': showListViewToggler,
    'c-section__header--heading-shown': props.Heading,
    'c-section__header--double-column':
      props.CurrentPageProps.BlockTypeName == 'DoubleColumnBlock',
  });

  return (
    <Section Modifiers={modifiers}>
      <header className={sectionHeader}>
        {props.Heading ? (
          <h2 className="c-section__heading">
            <span>{props.Heading}</span>
          </h2>
        ) : (
          <h2 className="show-for-sr">{props.Translations?.currentarticles}</h2>
        )}
        {showListViewToggler && (
          <EventListViewToggler
            Language={props.CurrentPageProps.Language}
            translations={props.Translations}
            onClick={(value) => {
              setToggleBrickView(value);
            }}
            toggleBrickView={toggleBrickView}
          />
        )}
      </header>
      {props.Items && (
        <ListChildren {...props} toggleBrickView={toggleBrickView} />
      )}
      {props.children}
    </Section>
  );
};

export { EventTeaser, EventTeaserItemLink };
